<div
  class="notification-wrapper"
  (click)="onBackdropClick($event)"
  [ngClass]="{
    hidden: notifications().length === 0,
    'display-backdrop': displayBackdrop()
  }"
>
  @for (notification of notifications(); track notification.hash; let index = $index) {
    <div
      class="notification"
      animate.enter="enter-animation"
      animate.leave="leave-animation"
      [ngClass]="{
        'notification-info': notification.type === 'info',
        'notification-success': notification.type === 'success',
        'notification-error': notification.type === 'error',
        'notification-loading': notification.type === 'loading',
        'notification-popup': notification.type === 'prompt'
      }"
      [style.top.px]="index * 60 + (index + 1) * 24"
    >
      <span class="message" [innerHTML]="notification.message"> </span>
      @if (notification.type === 'prompt') {
        <span class="buttons">
          <span (click)="respond(notification.hash, true)" class="icon icon-checkbox-round"></span>
          <span (click)="respond(notification.hash, false)" class="icon icon-remove-circle-filled-x"></span>
        </span>
      }
      @if (notification.type === 'success') {
        <span class="icon-container">
          <span class="icon icon-double-checkmark pl-2"></span>
        </span>
      }
      @if (notification.type === 'loading') {
        <span class="icon-container">
          <span class="icon-loading-circle"></span>
        </span>
      }
    </div>
  }
</div>
